import React, { Component } from "react";
import ReactFileReader from "react-file-reader";
import { callApi } from "../../utils/api";
import { cloneDeep } from "lodash";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import moment from "moment";
import { notifyToUser } from "../../utils/firebase";
import { FRONTOFFICE_ROLE, MANAGER_ROLE } from "../../utils/role";
import { pushnotificationApi } from "../../utils/pushNotify";
import Select from 'react-select';
declare var $: any;
interface Query {
  query: string;
  review: string;
  location: string;
  other_review: string;
  created_date: String;
  query_id?: string | number;
  is_checked?: boolean;
}
interface AllProps {
  match: any;
  history: any;
}
export default class AddQuery extends Component<AllProps> {
  state = {
    querydetail: [],
    office_users: [],
    remote_users: [],
    remote_cc_users: [],
    isLoading: false,
    base: [],
    docToPreview: "",
    queryLoading: false,
    queryQues: [],
    oldQueryQues: [],
    quesSubmitted: false,
    documentBaseList: [],
    reasons: [],
    required: false,
    fileNotCompleteMsg: { __html: '' },
    bankWithLawhadnsBranch: [],
    bank_private_name_id: '',
    product_id: '',
    lawhands_branch_id: '',
  };
  componentDidMount() {

    this.addItem();
    this.getFileDetail();
    this.liveinsert();
    this.listreason();
    this.getFilesDetails();
    this.getBankWithLawhandsBranch();
    this.fetchQueryNotes();
    // if (localStorage.getItem("BankTemplate")) {
    //   var bankTemp: any = localStorage.getItem("BankTemplate");
    //   this.setState({ bank_templates: JSON.parse(bankTemp) })
    // } else {
    //   this.getTemplates();
    // }
  }
  getBankWithLawhandsBranch() {
    callApi("GET", "bank_branch_get_management.php")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ bankWithLawhadnsBranch: result.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getFilesDetails = () => {
    callApi("POST", "search.php", {
      file_name: this.props.match.params.fileid
    })
      .then(res => res.data)
      .then(response => {
        if (response['data'] && response['data'][0]) {
          const bank_private_name_id = response['data'][0].bank_private_name_id;
          const product_id = response['data'][0].bank_product;
          const lawhands_branch_id = response['data'][0].lawhands_branch_id;
          this.setState({ bank_private_name_id, product_id, lawhands_branch_id });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  getTemplates = () => {
    callApi("POST", "bank_temp_get.php")
      .then(res => res.data)
      .then(response => {
        let banks = response.data;
        const vetting = banks.filter(item => item.name.split(" ").pop() != "Vetting");
        this.setState({ bank_templates: vetting });
        var bankTempName = [];
        bankTempName = vetting;
      })
      .catch(err => {
        console.log(err);
      });
  };
  listreason = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "query_reason_get.php")
      .then(res => res.data)
      .then(response => {
        const files = response.data;
        this.setState({ reasons: files });
      })
      .catch(err => {
        console.log(err);
      });
  };
  validateQuery = () => {
    let base: any = this.state.querydetail;
    let isValid = true;
    for (let i = 0; i < base.length; i++) {
      const document = base[i];
      if (document.review == "other") {
        if (!document.query || !document.review || !document.other_review) {
          isValid = false;
          base[i].isValid = false;
        } else {
          base[i].isValid = true;
        }
      } else {
        if (!document.query || !document.review) {
          isValid = false;
          base[i].isValid = false;
        } else {
          base[i].isValid = true;
        }
      }
    }
    return isValid;
  };
  hasUncheckedPendingWithoutRequery = () => {
    const querydetail: any[] = Array.isArray(this.state.querydetail) ? this.state.querydetail : [];
    const pendingItems = querydetail.filter(
      (item: any) => item && item.query_id && item.is_checked === false
    );

    if (!pendingItems.length) {
      return false;
    }

    return pendingItems.some((pending: any) => {
      const pendingId = String(pending.query_id);
      return !querydetail.some(
        (entry: any) =>
          entry &&
          String(entry.query_id || "") === pendingId &&
          entry.is_checked !== false
      );
    });
  };
  checkRestriction = async () => {
    const response = await callApi("POST", "check_restriction.php", {
      id: this.props.match.params.fileid,
      file_status: 6,
      flag: 'new_query'
    }).then((res) => res.data);
    if (response.response_Code === 201) {
      $("#file_not_complete_modal").modal('show');
      this.setState({ fileNotCompleteMsg: { __html: response.message } });
      return true;
    }
    return false;
  }
  showQueryquestion = async () => {
    const checkRestrict = await this.checkRestriction();
    if (checkRestrict) return;
    const mailToBank: any = localStorage.getItem("mail-bank");
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");
    this.setState({ required: true });
    let isValid = this.validateQuery();
    if (this.hasUncheckedPendingWithoutRequery()) {
      ToastsStore.error("Please check or re-query all pending queries before submit");
      return;
    }
    if (isValid) {
      if (userDGrade === "D" || fileDGrade === "D") {
        if (mailToBank === 'true') {
          $("#myModal").modal("show");
        } else {
          // without mail raise query
          this.saveQuery();
        }
      } else {
        $("#myModal").modal("show");
      }
    } else {
      ToastsStore.error("Please fill all the required fields");
    }
    setTimeout(() => {
    }, 1000);
    this.getUsers();
    this.getQueryQuestion();
  }
  liveinsert = () => {

    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["team_type"] : "";
    const userId = user ? JSON.parse(user)["userId"] : "";
    const role = user ? JSON.parse(user)["teamType"] : "";
    const role_type = user ? JSON.parse(user)["roleType"] : "";
    const user_name = user ? JSON.parse(user)["userName"] : "";
    const bankName: any = localStorage.getItem("bankName");
    const fileNamCode: any = localStorage.getItem("fileNamCode");
    const in_reason: any = localStorage.getItem("in_reason");
    let dateTime = new Date();
    let curentTime = dateTime.toLocaleTimeString();
    const textRay = `For Query Raise To Open  : ${this.props.match.params.fileid}`;
    let obj = {
      file_no: fileNamCode,
      in_time: curentTime,
      reason: in_reason,
      user_id: userId,
      user_name: user_name,
      team_type: role,
      role_type: role_type,
      working_process: textRay,
      bank_name: bankName,
    }
    callApi("POST", "live_track_insert.php", obj)
      .then(res => res.data)
      .then(response => {

      })
  }
  getFileDetail = () => {
    callApi("POST", "front_office_get.php", {
      id: this.props.match.params.fileid,
    })
      .then((res) => res.data)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.length &&
          response.data[0].arr &&
          response.data[0].arr.length
        ) {
          const state = response.data[0].arr[0];
          state.base = response.data[0].base
            ? response.data[0].base.map((base) => {
              return {
                ...base,
                isSavedFile: true,
              };
            })
            : [];
          this.setState({ documentBaseList: state.base });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getUsers = () => {
    const remote_users: any = [];
    callApi("POST", "office_details.php", {
      id: this.props.match.params.fileid,
    })
      .then((res) => res.data)
      .then((response) => {
        response.data.map((user) => {
          remote_users.push({ email: user.email, name: user.name });
        });
        this.setState({
          office_users: response.data,
          remote_users,
          remote_cc_users: remote_users,
        });
      });
  };
  getQueryQuestion = () => {
    callApi("POST", "query_question_get.php", {
      id: this.props.match.params.fileid,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          queryQues: response.data,
          oldQueryQues: JSON.parse(JSON.stringify(response.data)),
        });
      });
  };
  addItem = (): void => {
    const querydetail: Query[] = this.state.querydetail
      ? this.state.querydetail
      : [];
    querydetail.push({
      query: "",
      review: "",
      location: "",
      other_review: "",
      created_date: moment().format("DD-MM-YYYY HH:mm:ss"),
    });
    this.setState({ querydetail });
  };
  removeItem = (index: number): void => {
    const querydetail: Query[] = this.state.querydetail;
    querydetail.splice(index, 1);
    this.setState({ querydetail });
  };
  handleChange = (e: any, index: number) => {
    const querydetail: Query[] = this.state.querydetail;
    querydetail.forEach((itm: any, i) => {
      if (i === index) {
        itm[e.target.name] = e.target.value;
      }
    });
    this.setState({ querydetail });
  };
  handleDetailsChange = (value, index, key) => {
    let baseArray = cloneDeep(this.state.querydetail);
    baseArray[index] = {
      ...baseArray[index],
      [key]: value,
    };
    this.setState({ querydetail: baseArray }, () => {
    });
  };
  selectUser = (e: any, user: any) => {
    let remote_users: any = this.state.remote_users;
    if (e.target.checked) {
      remote_users.push({ email: user.email, name: user.name });
    } else {
      remote_users = remote_users.filter((itm) => itm.email !== user.email);
    }
    this.setState({ remote_users });
  };
  selectCcUser = (e: any, user: any) => {
    let remote_users: any = this.state.remote_cc_users;
    if (e.target.checked) {
      remote_users.push({ email: user.email, name: user.name });
    } else {
      remote_users = remote_users.filter((itm) => itm.email !== user.email);
    }
    this.setState({ remote_cc_users: remote_users });
  };
  saveQuery = () => {
    this.props.match.params.id = Number(this.props.match.params.id);
    const queryInput = Object.create({});
    queryInput.querydetail = this.state.querydetail;
    queryInput.remote_users = this.state.remote_users;
    queryInput.remote_cc_users = this.state.remote_cc_users;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    queryInput.user_idfk = userId;
    const report_to = user ? JSON.parse(user)["report_to"] : "";
    const firstName = user ? JSON.parse(user)["firstName"] : "";
    const mailToBank: any = localStorage.getItem("mail-bank");
    queryInput.fod_fk = this.props.match.params.fileid;
    queryInput.query_id = this.props.match.params.queryid;
    queryInput.base = this.state.base;
    this.setState({ queryLoading: true });
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");
    let apiPath;
    if (userDGrade === "D" || fileDGrade === "D") {
      apiPath = mailToBank === 'true' ? "query_create.php" : "query_create_without_mail.php";
    } else {
      apiPath = "query_create.php";
    }
    callApi("POST", apiPath, queryInput)
      .then((res) => res.data)
      .then((response) => {
        if (response.success == true) {
          localStorage.setItem("query_raised_status", JSON.stringify(true));
          this.timeUpdate(this.props.match.params.fileid);

          const filterBankLHBranch: any = this.state.bankWithLawhadnsBranch.find(
            (bank: any) =>
              bank?.bank_id == this.state?.bank_private_name_id &&
              bank?.product == this.state?.product_id &&
              bank?.lawhands_branch == this.state?.lawhands_branch_id
          );

          const isAutoMail = filterBankLHBranch?.autoMail === '1';
          const preliminaryPDF = filterBankLHBranch?.preliminaryPDF === '1';

          const isReportSendMail = isAutoMail && preliminaryPDF;

          if (isReportSendMail) {
            const payload = {
              file_id: this.props.match.params.fileid,
              generate_send_pdf: preliminaryPDF,
              "file_status": "Query Raise Auto Trigger",
              "created_by": userId
            };

            this.sendUploadPayload(payload);
          }

          // const user: any = localStorage.getItem("user");
          // const userId = user ? JSON.parse(user)["userId"] : "";
          const userName = user ? JSON.parse(user)["firstName"] : "";
          const notifyData = {
            title: `${this.props.match.params.fileid}Query Raised`, notifyType: "message", updatedAt: moment().format("YYYY-MM-DD HH:mm:ss")
          };
          let user_id = userId;
          pushnotificationApi(notifyData, user_id);
          const branchManger: any = localStorage.getItem("branch_manager");
          const branch_Manager = JSON.parse(branchManger);
          const queryOfficer: any = localStorage.getItem("Query_officer");
          const query_ooficer = JSON.parse(queryOfficer);
          const Scan_officer: any = localStorage.getItem("scan_officer");
          const sacanofficer = JSON.parse(Scan_officer);
          const process_mennager: any = localStorage.getItem("process_manager");
          const processManager = JSON.parse(process_mennager);
          if (Array.isArray(branch_Manager) && branch_Manager.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, branch_Manager);
            const branchManager = branch_Manager.join(",");
            let obj = {
              // notification_type:"queryraised",
              user_id: branchManager,
              ...notifyData
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (Array.isArray(query_ooficer) && query_ooficer.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "notify" }, query_ooficer);
            const OfficerQuery = query_ooficer.join(",");
            let obj = {
              // notification_type:"queryraised",
              user_id: OfficerQuery,
              ...notifyData
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (Array.isArray(processManager) && processManager.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, processManager);
            const ProcessManager = processManager.join(",");
            let obj = {
              // notification_type:"queryraised",
              user_id: ProcessManager,
              ...notifyData
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
          //  notifyToUser("user",{...notifyData,notifyType:'message'},[FRONTOFFICE_ROLE]);
          this.setState({ queryLoading: false, quesSubmitted: false });
          $("#myModal").modal("hide");
          ToastsStore.success("Queries added Successully");
          // setTimeout(() => {
          //   this.props.history.push("/inprogress-file");
          // }, 2000);
          this.getOutTime();
        } else {
          this.setState({ queryLoading: false, quesSubmitted: true });
          ToastsStore.error(response.message);
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ queryLoading: false, quesSubmitted: true });
        // $("#myModal").modal("hide");
        ToastsStore.error("Something went Wrong, Please try again!");
      });
  };
  sendUploadPayload = async (payload: any) => {
    callApi("POST", "auto_mail_report_send.php", payload)
      .then(res => res.data)
      .then(response => { }).catch(err => { });
  };
  getOutTime = async () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime))
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
    else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
    await this.processEod();
  }
  processEod = () => {
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    console.log("70", intime);
    const outtime: any = localStorage.getItem("outtimeGet");
    console.log("73", outtime);
    const outdate: any = localStorage.getItem("OutDateGet");
    const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
    console.log('Second Spn', secondsSpent);
    let updatedRemainingTime: any = localStorage.getItem('updatedRemainingTime');
    let updatedtime = Math.round(updatedRemainingTime);
    const status: any = localStorage.getItem("dashboard_status");
    const insertId: any = localStorage.getItem("ProcessEodInsertID");
    let obj = {
      "file_id": JSON.parse(fileid1),
      "user_id": JSON.parse(userid1),
      "in_reason": JSON.parse(inreason),
      "out_reason": "Query Raised",
      "intime": JSON.parse(intime),
      "outtime": JSON.parse(outtime),
      "insert_date": JSON.parse(outdate),
      "total_seconds": secondsSpent,
      "balance_min": updatedtime,
      "dashboard_status": status,
      "insert_id": insertId
    }
    callApi("POST", "process_eod_insert.php", obj)
      .then(res => res.data)
      .then(response => {
        localStorage.removeItem('updatedRemainingTime');
        localStorage.removeItem("in_reason");
        localStorage.removeItem("outreason");
        localStorage.removeItem("IntimeGet");
        localStorage.removeItem("OutDateGet");
        $("#out_reason").modal("hide");
        $("#another-reason").modal("hide");
        // ToastsStore.success("Your Reason Saved Successfully");
        localStorage.removeItem('currentfileId');
        localStorage.removeItem("query_raised_status");
        localStorage.removeItem("file_completed_status");
        setTimeout(() => {
          const fileurl: any = localStorage.getItem("url");
          if (fileurl == "") {
            this.props.history.push("/inprogress-file");
          } else {
            this.props.history.push(fileurl);
          }
        }, 500);
      }).catch((err) => {
        console.log(err);
      })
  }
  timeUpdate = (fileid) => {
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      query_raised_by: JSON.parse(loginuser),
      id: fileid,
      reason: "Query Raised",
      created_by: JSON.parse(loginuser),
      color: "#afa5bd"
    }
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {

      });
  }

  handleFiles = (files: any) => {
    let baseFile: any = this.state.base || [];
    const fileSize = [...files.fileList].reduce((a, b) => +a + +b.size, 0);
    if (Number(fileSize) > 26214400) {
      ToastsStore.error("File(s) size shouldn't exceed 25 MB");
    } else {
      files.base64.map((file: any, index: number) => {
        baseFile.push({
          file,
          fileType: files.fileList[index].type,
          fileName: files.fileList[index].name,
        });
      });
      this.setState({ base: [...baseFile] });
    }
  };

  deleteDoc = (modal, index) => {
    const baseFile: never[] = cloneDeep(this.state.base);
    baseFile.splice(index, 1);
    this.setState({ base: [...baseFile] });
  };

  previewDoc = (modal) => {
    this.setState({ docToPreview: modal.file });
  };

  handleAnswerChange = (index, val) => {
    const queryQues: any = this.state.queryQues;
    queryQues[index].answer = val;
    this.setState({ queryQues });
  };
  fetchQueryNotes = () => {
    const fileId = this.props.match.params.fileid;

    const payload: any = {};
    if (fileId) payload.fileId = fileId;

    callApi("POST", "query_validation_notes_get.php", payload)
      .then((res) => res.data)
      .then((response) => {
        if (response.success && response.data) {
          this.setState({
            querydetail: response.data.querydetail || [],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  saveQueryQuestion = () => {
    const { queryQues, oldQueryQues } = this.state;
    const user: any = localStorage.getItem("user");
    const obj = {
      fileNo: this.props.match.params.fileid,
      currentData: queryQues,
      oldData: oldQueryQues,
      loginId: user ? JSON.parse(user)["userId"] : "",
    };

    callApi("POST", "queryverification_checklist.php", obj)
      .then((res) => res.data)
      .then((response) => {
        this.setState({ quesSubmitted: true });
      })
      .catch((err) => { });
  };
  render() {
    const { queryQues, quesSubmitted, documentBaseList } = this.state;
    const banktemplatesoption = [
      ...this.state.reasons,
      { value: "other", label: "Other" }
    ];
    return (
      <div className="pcoded-main-container">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div
                      className={`col-sm-${documentBaseList && documentBaseList.length > 0
                        ? "8"
                        : "12"
                        }`}
                    >
                      <div className="card">
                        <div className="card-header">
                          <h5>Query Post</h5>
                        </div>
                        <div className="card-body">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={this.addItem}
                            >
                              <i className="feather icon-plus" />
                              ADD
                            </button>
                          </div>
                          {this.state.querydetail &&
                            this.state.querydetail.length
                            ? this.state.querydetail.map(
                              (queryItem: Query, index: number) => {
                                return (
                                  <div className="row" key={index}>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label>Query</label>{" "}
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="query"
                                          placeholder=""
                                          value={queryItem.query}
                                          onChange={(e) =>
                                            this.handleChange(e, index)
                                          }
                                        />
                                      </div>
                                      {this.state.required && !queryItem.query && <p style={{ color: "red", fontSize: "14px", marginTop: "-10px" }}>Required field.</p>}
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Reason</label>
                                        <div className="query-template-select">
                                          {this.state.reasons && this.state.reasons.length > 0 && this.state.reasons.map((opt: any) => {
                                            opt.label = opt.reason; opt.value = opt.reason
                                          }) && (
                                              <Select
                                                options={banktemplatesoption}
                                                name="review"
                                                onChange={(selectedOption) =>
                                                  this.handleDetailsChange(selectedOption.value, index, 'review')
                                                }
                                                value={this.state.reasons.find(
                                                  (o: any) => o.value === queryItem.review
                                                )}
                                              />
                                            )}
                                        </div>
                                        {this.state.required && !queryItem.review && <p style={{ color: "red", fontSize: "14px", marginTop: "-10px" }}>Required field.</p>}
                                        {queryItem.review === "other" ? (
                                          <>
                                            <div className="">
                                              <label>Other Reason</label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                name="other_review"
                                                placeholder=""
                                                value={queryItem.other_review}
                                                onChange={(e) => this.handleChange(e, index)}
                                              />
                                            </div>
                                            {this.state.required && !queryItem.other_review && <p style={{ color: "red", fontSize: "14px" }}>Required field.</p>}
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label>Location</label>{" "}
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="location"
                                          placeholder=""
                                          value={queryItem.location}
                                          onChange={(e) =>
                                            this.handleChange(e, index)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-2">
                                      <button
                                        type="button"
                                        className="btn btn-icon btn-rounded btn-danger"
                                        style={{
                                          marginTop: "35px",
                                        }}
                                        disabled={
                                          this.state.querydetail.length === 1
                                        }
                                        onClick={() => this.removeItem(index)}
                                      >
                                        <i className="feather icon-minus" />
                                      </button>
                                    </div>
                                  </div>
                                );
                              }
                            )
                            : ""}
                          <ReactFileReader
                            fileTypes={[".pdf"]}
                            base64={true}
                            multipleFiles={true}
                            handleFiles={this.handleFiles}
                          >
                            <button
                              className="ml2 btn btn-primary btnupload float-right query-upload"
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                              ) : (
                                "Upload Document"
                              )}
                            </button>
                          </ReactFileReader>
                          <div className="query-document">
                            {this.state.base && this.state.base.length
                              ? this.state.base.map(
                                (itm: any, index: number) => {
                                  return (
                                    <div key={index}>
                                      <div className="card card-border-c-green">
                                        <span
                                          onClick={() =>
                                            this.deleteDoc(itm, index)
                                          }
                                        >
                                          <i className="feather icon-x cursor-pointer" />
                                        </span>
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            <span className="mb-1 text-c-green">
                                              <i className="feather icon-file-text" />
                                            </span>
                                            <span>{itm.fileName || ""}</span>
                                            <span
                                              style={{ float: "right" }}
                                              className="cursor-pointer"
                                              data-toggle="modal"
                                              data-target="#preview-document"
                                              onClick={() =>
                                                this.previewDoc(itm)
                                              }
                                            >
                                              <i className="fa fa-eye" />
                                            </span>
                                          </h5>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )
                              : ""}
                          </div>
                          {this.state.docToPreview && (
                            <div
                              className={`modal ${this.state.docToPreview ? "open" : ""
                                }`}
                              id="preview-document"
                              role="dialog"
                              aria-hidden="true"
                            >
                              <div
                                className="modal-dialog modal-lg"
                                role="document"
                              >
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      Document Preview
                                    </h5>
                                    <button
                                      type="button"
                                      className="close cursor-pointer"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      onClick={() =>
                                        this.setState({ docToPreview: "" })
                                      }
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <iframe
                                      width="100%"
                                      height="400px"
                                      src={this.state.docToPreview}
                                    ></iframe>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      data-dismiss="modal"
                                      onClick={() =>
                                        this.setState({ docToPreview: "" })
                                      }
                                    >
                                      Close
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div>
                            <div>
                              <div className="form-group">
                                <a
                                  className="btn btn-primary md-trigger"
                                  onClick={() => this.showQueryquestion()}
                                >
                                  Submit
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {documentBaseList && documentBaseList.length > 0 && (
                      <div className="col-sm-4">
                        <div className="row">
                          <div className="dt-responsive table-responsive bg-white">
                            <table
                              id="bank-files-table"
                              className="table nowrap"
                            >
                              <thead>
                                <tr>
                                  <th style={{ background: "lightgrey" }}>
                                    S.no
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ background: "lightgrey" }}
                                  >
                                    Doc.No/Year
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ background: "lightgrey" }}
                                  >
                                    Category
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {documentBaseList &&
                                  documentBaseList.length > 0 &&
                                  documentBaseList.map((item: any, index) => (
                                    <tr>
                                      <th>{index + 1}</th>
                                      <th className="text-center">
                                        {item.docNoYear || "-"}
                                      </th>
                                      <th className="text-center text-capitalize">
                                        {item.type.replaceAll("_", " ") || "-"}
                                      </th>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal" id="myModal">
                    <div className="modal-dialog modal-lg">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4 className="modal-title">Send Mail</h4>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                          >
                            &times;
                          </button>
                        </div>
                        <div className="modal-body">
                          {!quesSubmitted && (
                            <div className="query-question">
                              <div className="row">
                                {queryQues.map((ques: any, index) => (
                                  <div className="col-md-6" key={index}>
                                    <div className="question">
                                      <p>{ques.query_question}</p>
                                      <div className="row">
                                        <div className="col-md-3">
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="radio"
                                              className=""
                                              name={`answer-${index}`}
                                              defaultChecked
                                              onChange={() =>
                                                this.handleAnswerChange(
                                                  index,
                                                  true
                                                )
                                              }
                                            />
                                            <label className="">Yes</label>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="radio"
                                              className=""
                                              name={`answer-${index}`}
                                              onChange={() =>
                                                this.handleAnswerChange(
                                                  index,
                                                  false
                                                )
                                              }
                                            />
                                            <label className="">No</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-info"
                                  onClick={this.saveQueryQuestion}
                                >
                                  <span>Submit</span>
                                </button>
                              </div>
                            </div>
                          )}
                          {quesSubmitted && (
                            <div className="row">
                              <div className="col-md-6">
                                <label>To:</label>
                                <div className="form-group">
                                  {this.state.office_users &&
                                    this.state.office_users.length ? (
                                    this.state.office_users.map(
                                      (user: any, index) => {
                                        return (
                                          <div
                                            className="custom-control custom-checkbox"
                                            key={index}
                                          >
                                            <input
                                              type="checkbox"
                                              className=""
                                              onChange={(e) =>
                                                this.selectUser(e, user)
                                              }
                                              defaultChecked
                                            />
                                            <label className="">
                                              {user.name + " - " + user.email}
                                            </label>
                                          </div>
                                        );
                                      }
                                    )
                                  ) : (
                                    <button
                                      // onClick={this.addItem}
                                      className="btn btn-primary m-b-20"
                                    >
                                      + Add User
                                    </button>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <label>Cc:</label>
                                <div className="form-group">
                                  {this.state.office_users &&
                                    this.state.office_users.length ? (
                                    this.state.office_users.map(
                                      (user: any, index) => {
                                        return (
                                          <div
                                            className="custom-control custom-checkbox"
                                            key={index}
                                          >
                                            <input
                                              type="checkbox"
                                              className=""
                                              onChange={(e) =>
                                                this.selectCcUser(e, user)
                                              }
                                              defaultChecked
                                            />
                                            <label className="">
                                              {user.name + " - " + user.email}
                                            </label>
                                          </div>
                                        );
                                      }
                                    )
                                  ) : (
                                    <button
                                      // onClick={this.addItem}
                                      className="btn btn-primary m-b-20"
                                    >
                                      + Add User
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {quesSubmitted && (
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-danger"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-info"
                              // data-dismiss="modal"
                              disabled={this.state.queryLoading}
                              onClick={this.saveQuery}
                            >
                              {this.state.queryLoading ? (
                                <div className="spinner-border" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                <span>Send</span>
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal hide fade in" id="file_not_complete_modal" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                      <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                        <div className="modal-body">
                          <h5 style={{ textAlign: 'left' }} dangerouslySetInnerHTML={this.state.fileNotCompleteMsg}></h5>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-success"
                            data-dismiss="modal"
                            style={{ width: '50%', fontSize: '17px', margin: 'auto' }}
                          > Ok</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
